import * as ActionTypes from '../../actions/types/website/BannerActionTypes';

const initialState = {
  busy: false,
  list: [],
  selectedBannerId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_BANNER_LIST: {
      return { ...state, busy: true };
    }

    case ActionTypes.RECEIVE_BANNER_LIST: {
      const { list } = action.payload;
      return { ...state, list, busy: false };
    }

    case ActionTypes.RECEIVE_BANNER_ID: {
      const { id } = action.payload;
      return { ...state, selectedBannerId: id };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/website/banners.js